import React from 'react';
import styled from 'styled-components';

import { FormControl, FormField, FormItem, FormLabel } from './Form';
import { FeatureSwitch } from '../../views/offers/styles';
import { Palette } from '../utils';

const ToggleInput = ({ form, name, label, description, disabled = false }) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <Container>
            <div>
              <FormLabel>{label}</FormLabel>
              <StyledDescription>{description}</StyledDescription>
            </div>
            <StyledFormControl>
              <FeatureSwitch
                shape="pill"
                color="primary"
                value={disabled ? false : field.value}
                checked={disabled ? false : field.value}
                disabled={disabled}
                onChange={field.onChange}
                {...field}
              />
            </StyledFormControl>
          </Container>
        </FormItem>
      )}
    />
  );
};

export default ToggleInput;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  label {
    font-size: 14px;
  }
`;

const StyledFormControl = styled(FormControl)`
  width: min-content;

  .c-switch-pill {
    width: 50px;
    height: 27.5px;
  }

  .c-switch-slider::before {
    width: 22.388px;
    height: 22.388px;
    top: 1.45px;
  }

  // Selects the circle of the toggle when it's checked
  .c-switch-input:checked + .c-switch-slider::before {
    left: 11px;
  }
`;

export const StyledDescription = styled.p`
  margin-bottom: 0;
  color: ${Palette.CONTENT_TERTIARY};
`;
